<template>
  <div id="call-detail">
    <div class="title-label">{{ screenTitleName }}</div>
    <p class="attention">
      このコール詳細画面はコールセンターが記録する画面です。<span
        class="text-red"
        >営業担当は情報の参照のみとし、<span class="strong"
          >更新はしないでください。</span
        ></span
      >
    </p>
    <div class="button-area">
      <b-button class="backButton is-primary" @click="sendBack">戻る</b-button>
    </div>
    <div id="call-detail-content-area">
      <div id="left-area">
        <div class="call-detail-content">
          <p class="call-type-label">{{ callTypeTitleName }}</p>
          <div class="button-area">
            <b-button
              class="clipboard-copy-button is-primary"
              @click="clipboardCopy"
            >
              クリップボードにコピー
            </b-button>
          </div>
          <table id="call-detail-table">
            <tr>
              <th>{{ tableNameMap.callId.label }}</th>
              <td>{{ callDetailData.callId }}</td>
            </tr>
            <tr>
              <th>{{ tableNameMap.patientCode.label }}</th>
              <td>{{ convertDisplayByDeviceType(callDetailData.patientCode) }}</td>
            </tr>
            <tr>
              <th>{{ tableNameMap.patientName.label }}</th>
              <td>{{ callDetailData.patientName }}</td>
            </tr>
            <tr>
              <th>{{ tableNameMap.patientPostcode.label }}</th>
              <td>{{ callDetailData.patientPostcode }}</td>
            </tr>
            <tr>
              <th>{{ tableNameMap.patientAddress.label }}</th>
              <td>{{ callDetailData.patientAddress }}</td>
            </tr>
            <tr>
              <th>{{ tableNameMap.patientAddressHouseNumber.label }}</th>
              <td>{{ callDetailData.patientAddressHouseNumber }}</td>
            </tr>
            <tr>
              <th>{{ tableNameMap.patientAddressBuildingName.label }}</th>
              <td>{{ callDetailData.patientAddressBuildingName }}</td>
            </tr>
            <tr>
              <th>{{ tableNameMap.chargeBranchName.label }}</th>
              <td>{{ callDetailData.chargeBranchName }}</td>
            </tr>
            <tr>
              <th>{{ tableNameMap.salesStaffName.label }}</th>
              <td>{{ callDetailData.salesStaffName }}</td>
            </tr>
            <tr>
              <th>{{ tableNameMap.medicalInstitutionName.label }}</th>
              <td>{{ callDetailData.medicalInstitutionName }}</td>
            </tr>
            <tr>
              <th>{{ tableNameMap.medicalInstitutionCode.label }}</th>
              <td>{{ callDetailData.medicalInstitutionCode }}</td>
            </tr>
            <tr>
              <th>{{ tableNameMap.deviceItemCode.label }}</th>
              <td>{{ convertDeviceModelName() }}</td>
            </tr>
            <tr>
              <th>{{ tableNameMap.deviceSerial.label }}</th>
              <td>{{ callDetailData.deviceSerial }}</td>
            </tr>
            <tr>
              <th>{{ tableNameMap.cpapBillingTargetCode.label }}</th>
              <td>{{ convertDisplayByDeviceType(callDetailData.cpapBillingTargetCode) }}</td>
            </tr>
            <tr>
              <th>{{ tableNameMap.cpapBillingTargetName.label }}</th>
              <td>{{ convertDisplayByDeviceType(callDetailData.cpapBillingTargetName) }}</td>
            </tr>
            <tr v-if="callDetailData.scheduledReturnDate && !callDetailData.isDeviceReturned">
              <th class="strong">{{ tableNameMap.scheduledReturnDate.label }}</th>
              <td class="strong text-red">{{ callDetailData.scheduledReturnDate }}</td>
            </tr>
            <tr v-if="callDetailData.delayedDays && !callDetailData.isDeviceReturned">
              <th class="strong">{{ tableNameMap.delayedDays.label }}</th>
              <td class="strong text-red">{{ callDetailData.delayedDays }}日</td>
            </tr>
            <tr v-if="callDetailData.isDeviceReturned">
              <th class="strong">{{ tableNameMap.scheduledReturnDate.label }}</th>
              <td class="strong text-red">機器返却済み</td>
            </tr>
            <tr>
              <th class="strong">{{ tableNameMap.patientMobilePhone.label }}</th>
              <td class="strong text-red">
                {{ convertDisplayByDeviceType(callDetailData.patientMobilePhone) }}
              </td>
            </tr>
            <tr>
              <th class="strong">{{ tableNameMap.patientPhoneNumber.label }}</th>
              <td class="strong text-red">
                {{ callDetailData.patientPhoneNumber }}
              </td>
            </tr>
            <tr>
              <th class="strong">{{ tableNameMap.patientNameKana.label }}</th>
              <td class="strong text-red">{{ callDetailData.patientNameKana }}</td>
            </tr>
            <tr>
              <th><br /></th>
              <td></td>
            </tr>
            <tr>
              <th>
                {{ tableNameMap.callStaffName.label }}<span class="require" />
              </th>
              <td>
                <input
                  v-model="callDetailData.callStaffName"
                  type="text"
                  class="validation"
                  :name="tableNameMap.callStaffName.label"
                  validate="required"
                  maxlength="256"
                />
              </td>
            </tr>
            <tr>
              <th>
                {{ tableNameMap.callImplementationDate.label
                }}<span class="require" />
              </th>
              <td>
                <input
                  v-model="callDetailData.callImplementationDate"
                  type="date"
                  class="date-select validation"
                  :name="tableNameMap.callImplementationDate.label"
                  validate="required|date|birthDay"
                  :max="yyyy_hyp_MM_hyp_dd(new Date())"
                />
              </td>
            </tr>
            <tr>
              <th>
                {{ tableNameMap.callStartTime.label }}<span class="require" />
              </th>
              <td>
                <select
                  v-model="callStartHour"
                  class="time-select validation"
                  validate="required"
                  :name="tableNameMap.callStartTime.label + '(時)'"
                  @change="formatTime"
                >
                  <option></option>
                  <option v-for="i in 24" :key="i" :value="i - 1">
                    {{ i - 1 }}
                  </option>
                </select>
                時
                <select
                  v-model="callStartMinutes"
                  class="time-select validation"
                  validate="required"
                  :name="tableNameMap.callStartTime.label + '(分)'"
                  @change="formatTime"
                >
                  <option></option>
                  <option v-for="i in 60" :key="i" :value="i - 1">
                    {{ i <= 10 ? "0" + (i - 1) : i - 1 }}
                  </option>
                </select>
                分
              </td>
            </tr>
            <tr>
              <th>
                {{ tableNameMap.callEndTime.label }}<span class="require" />
              </th>
              <td>
                <select
                  v-model="callEndHour"
                  class="time-select validation"
                  validate="required"
                  :name="tableNameMap.callEndTime.label + '(時)'"
                  @change="formatTime"
                >
                  <option></option>
                  <option v-for="i in 24" :key="i" :value="i - 1">
                    {{ i - 1 }}
                  </option>
                </select>
                時
                <select
                  v-model="callEndMinutes"
                  class="time-select validation"
                  validate="required"
                  :name="tableNameMap.callEndTime.label + '(分)'"
                  @change="formatTime"
                >
                  <option></option>
                  <option v-for="i in 60" :key="i" :value="i - 1">
                    {{ i <= 10 ? "0" + (i - 1) : i - 1 }}
                  </option>
                </select>
                分
              </td>
            </tr>
            <tr v-show="isInvalidTimeSetting">
              <th></th>
              <td class="text-red">
                {{ invalidTimeSettingMessage }}
              </td>
            </tr>
            <tr>
              <th>{{ tableNameMap.callTurnaroundTimes.label }}</th>
              <td>
                <input
                  type="text"
                  class="turnaround-times"
                  name="所要時間"
                  :value="calculateCallTurnaroundTimes"
                  disabled
                />
                分
              </td>
            </tr>
            <tr>
              <th>
                {{ tableNameMap.callStatus.label }}<span class="require" />
              </th>
              <td>
                <select
                  v-model="callDetailData.callStatus"
                  class="validation"
                  :name="tableNameMap.callStatus.label"
                  validate="required"
                >
                  <option
                    v-for="status in callStatusList"
                    :key="status.code"
                    :value="status.code"
                  >
                    {{ status.name }}
                  </option>
                </select>
              </td>
            </tr>
            <tr>
              <th class="hearing-th">
                {{ tableNameMap.hearing1.label }}
              </th>
              <td>
                <textarea
                  v-model="callDetailData.hearing1"
                  class="hearing-content"
                  maxlength="256"
                />
              </td>
            </tr>
            <tr>
              <th class="hearing-th">
                {{ tableNameMap.hearing2.label }}
              </th>
              <td>
                <textarea
                  v-model="callDetailData.hearing2"
                  class="hearing-content"
                  maxlength="256"
                />
              </td>
            </tr>
            <tr>
              <th class="hearing-th">
                {{ tableNameMap.hearing3.label }}
              </th>
              <td>
                <textarea
                  v-model="callDetailData.hearing3"
                  class="hearing-content"
                  maxlength="256"
                />
              </td>
            </tr>
            <tr>
              <th class="hearing-th">
                {{ tableNameMap.hearing4.label }}
              </th>
              <td>
                <textarea
                  v-model="callDetailData.hearing4"
                  class="hearing-content"
                  maxlength="256"
                />
              </td>
            </tr>
            <tr v-if="isCall && callDetailData.callType == callTypeList[0].code">
              <th>コール実施</th>
              <td>
                <b-checkbox
                  v-model="callDetailData.hasAfterCall"
                  class="cstmCheckBox"
                  >到着後コールを行う</b-checkbox
                >
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div id="right-area">
        <div class="cpap-request-detail">
          <p class="content-label">申込み内容</p>
          <CpapRequestDetail v-if="callDetailData.deviceTypeCode == 'CPAP'" :data="callDetailData.requestDetailData" :innerUser="true" />
          <HstRequestDetail v-else-if="callDetailData.deviceTypeCode == 'HST'" :requestDetailData="callDetailData.requestDetailData" />
          <KenshinRequestDetail v-else-if="callDetailData.deviceTypeCode == 'CORP'" :requestDetailData="callDetailData.requestDetailData" />
          <HolterRequestDetail v-else-if="callDetailData.deviceTypeCode == 'HOLTER'" :requestDetailData="callDetailData.requestDetailData" />
        </div>
        <div class="history">
          <p class="content-label">対応状況</p>
          <CallHistoryDetailCard
            :callHistoryDataList="callDetailData.callHistoryDataList"
            :parentCallId="callDetailData.callId"
            @anotherCallDetail="findCallDetail"
          />
        </div>
      </div>
    </div>
    <div class="button-area">
      <b-button class="save-button is-primary" @click="saveCallDetail"
        >更新する</b-button
      >
      <b-button
        v-if="isCall && !callDetailData.escalationId"
        class="escalation-button is-primary"
        @click="showEscalation"
      >
        エスカレーション起票
      </b-button>
      <b-button class="backButton is-primary" @click="sendBack">戻る</b-button>
    </div>
    <floatingModal
      name="Escalation-modal"
      modalClass="Escalation-modal"
      width="900"
      height="680"
      top="5%"
      right="25%"
      @close="closeEscalation"
    >
      <EscalationCreationDialog :callDetail="callDetailData" v-on:sendBack="sendBack" />
    </floatingModal>
  </div>
</template>

<script>
import {
  cpapCallTypeList,
  cpapCallStatusList,
  escalationTypeList,
} from "@/components/mock/base/const.js";
import floatingModal from "@/components/mock/common/FloatingModal";
import CpapRequestDetail from "@/components/mock/common/CpapRequestDetail";
import HstRequestDetail from "./components/HstRequestDetailCard.vue";
import KenshinRequestDetail from "./components/KenshinRequestDetailCard.vue";
import HolterRequestDetail from "./components/HolterRequestDetailCard.vue";
import CallHistoryDetailCard from "./components/CallHistoryDetailCard.vue";
import EscalationCreationDialog from "./components/EscalationCreationDialog.vue";

export default {
  name: "CpapFollowUpCallDetail",
  data() {
    return {
      callId: "",
      searchParams: {},
      isCall: true,
      callDetailData: {},
      hasAfterCall: false,
      isShowEscalationDialog: false,
      callTypeList: cpapCallTypeList,
      callStatusList: cpapCallStatusList,
      escalationTypeList,
      cpapDeviceList: this.getCpapMaster(),
      inspectionDeviceList: [],
      tableNameMap: {
        callId: { label: "コールID", name: "callId" },
        patientCode: { label: "患者コード", name: "patientCode" },
        patientName: { label: "患者名", name: "patientName" },
        patientPostcode: { label: "郵便番号", name: "patientPostcode" },
        patientAddress: { label: "住所（都道府県、市町村区）", name: "patientAddress" },
        patientAddressHouseNumber: { label: "住所（それ以降の住所）", name: "patientAddressHouseNumber" },
        patientAddressBuildingName: { label: "住所（建物名、部屋番号）", name: "patientAddressBuildingName" },
        chargeBranchName: { label: "担当支店", name: "chargeBranchName" },
        salesStaffName: { label: "担当営業者名", name: "salesStaffName" },
        medicalInstitutionName: { label: "医療機関名", name: "medicalInstitutionName" },
        medicalInstitutionCode: { label: "病院コード", name: "medicalInstitutionCode" },
        deviceItemCode: { label: "該当機器名", name: "deviceItemCode" },
        deviceSerial: { label: "該当機器シリアル", name: "deviceSerial" },
        cpapBillingTargetCode: { label: "請求先コード", name: "cpapBillingTargetCode" },
        cpapBillingTargetName: { label: "請求先名", name: "cpapBillingTargetName" },
        scheduledReturnDate: { label: "返却予定日", name: "scheduledReturnDate" },
        delayedDays: { label: "遅延日数", name: "delayedDays" },
        patientMobilePhone: { label: "連絡先（携帯電話）", name: "patientMobilePhone" },
        patientPhoneNumber: { label: "連絡（自宅・その他）", name: "patientPhoneNumber" },
        patientNameKana: { label: "患者名（カナ）", name: "patientNameKana" },
        callStaffName: { label: "コール実施者名", name: "callStaffName" },
        callImplementationDate: { label: "対応日", name: "callImplementationDate" },
        callStartTime: { label: "対応開始時刻", name: "callStartTime" },
        callEndTime: { label: "対応終了時刻", name: "callEndTime" },
        callTurnaroundTimes: { label: "対応所要時間", name: "callTurnaroundTimes" },
        callStatus: { label: "コール結果", name: "callStatus" },
        hearing1: { label: "最終ヒアリング内容1", name: "hearing1" },
        hearing2: { label: "最終ヒアリング内容2", name: "hearing2" },
        hearing3: { label: "最終ヒアリング内容3", name: "hearing3" },
        hearing4: { label: "最終ヒアリング内容4", name: "hearing4" },
      },
      callStartHour: "",
      callStartMinutes: "",
      callEndHour: "",
      callEndMinutes: "",
      callTurnaroundTimes: "",
      isInvalidTimeSetting: false,
      invalidTimeSettingMessage: "対応終了時刻は対応開始時刻より後の時刻を設定してください",
    };
  },
  components: {
    floatingModal,
    CpapRequestDetail,
    HstRequestDetail,
    KenshinRequestDetail,
    HolterRequestDetail,
    CallHistoryDetailCard,
    EscalationCreationDialog,
  },
  methods: {
    sendBack() {
      this.$router.push({
        name: "CpapFollowUpCallList",
        params: { searchConditions: this.searchParams },
      });
    },

    findCallDetail(callId) {
      if(callId) {
        this.callId = callId;
      }
      let requestApi = this.findCallDetailApi;
      let successCallBack = this.findCallDetailApiSuccess;
      let errorCallBack = this.findCallDetailApiError;
      this.apiCall(requestApi, successCallBack, errorCallBack);
    },
    findCallDetailApi(client) {
      return client.apis.internalCpap.getCpapCallDetailsPOST({
        body: { callId: this.callId },
      });
    },
    findCallDetailApiSuccess(result) {
      this.callDetailData = result.obj;
      this.setSelectTimes();
    },
    findCallDetailApiError(error) {
      this.showErrorMessage(error.message, this.sendBack());
    },

    findInspectionDevices() {
      let requestApi = this.findInspectionDevicesApi;
      let successCallBack = this.findInspectionDevicesSuccess;
      let errorCallBack = this.findInspectionDevicesError;
      this.apiCall(requestApi, successCallBack, errorCallBack);
    },
    findInspectionDevicesApi(client) {
      return client.apis.internalDeviceManagement.getDeviceKindsPOST({
        body: {}
      });
    },
    findInspectionDevicesSuccess(result) {
      this.inspectionDeviceList = result.obj;
    },
    findInspectionDevicesError(error) {
      // this.showErrorMessage(error);
    },

    setSelectTimes() {
      if (this.callDetailData.callStartTime) {
        let callStartTime = this.callDetailData.callStartTime.split(":");
        this.callStartHour = Number(callStartTime[0]);
        this.callStartMinutes = Number(callStartTime[1]);
      }
      if (this.callDetailData.callEndTime) {
        let callEndTime = this.callDetailData.callEndTime.split(":");
        this.callEndHour = Number(callEndTime[0]);
        this.callEndMinutes = Number(callEndTime[1]);
      }
    },

    saveCallDetail() {
      let div = document.getElementById("call-detail-content-area");
      let elements = div.getElementsByClassName("validation");
      let result = this.selfMadeValidation(elements);
      if (result.isError) {
        this.showErrorMessage(result.msg);
        return;
      }
      if(this.isInvalidTimeSetting) {
        this.showErrorMessage(this.invalidTimeSettingMessage);
        return;
      }
      let requestApi = this.saveCallDetailApi;
      let successCallBack = this.saveCallDetailSuccess;
      let errorCallBack = this.saveCallDetailError;
      this.apiCall(requestApi, successCallBack, errorCallBack);
    },
    saveCallDetailApi(client) {
      return client.apis.internalCpap.setCpapCallDetailsPOST({
        body: this.callDetailData,
      });
    },
    saveCallDetailSuccess(result) {
      this.showSuccess(result, this.sendBack);
    },
    saveCallDetailError(error) {
      this.showErrorMessage(error);
    },
    showEscalation: function() {
      this.$modal.show('Escalation-modal')
    },
    closeEscalation: function() {
      this.$modal.hide('Escalation-modal')
    },

    formatTime() {
      this.callDetailData.callStartTime = `${this.callStartHour}:${this.callStartMinutes}`;
      this.callDetailData.callEndTime = `${this.callEndHour}:${this.callEndMinutes}`;
    },

    convertDisplayByDeviceType(val) {
      let text = "";
      if(this.callDetailData.deviceTypeCode == "CPAP") {
        text = val;
      } else {
        text = "ー";
      }
      return text;
    },
    convertDate(date) {
      return date ? date.replace(/-/g, "/") : "";
    },
    convertDeviceModelName() {
      let deviceName = "";
      let device = null;
      switch (this.callDetailData.deviceTypeCode) {
        case "CPAP":
          device = this.cpapDeviceList.find(item => item.itemCodes.indexOf(this.callDetailData.deviceItemCode) != -1);
          deviceName = device ? device.itemName : "";
          break;
        case "HST":
        case "CORP":
        case "HOLTER":
          device = this.inspectionDeviceList.find(item => item.value == this.callDetailData.inspectionDeviceId);
          deviceName = device ? device.kind : "";
          break;
        default:
          break;
      }
      return deviceName;
    },

    clipboardCopy() {
      let copyPasteText = "";
      let headerTextList = [];
      let dataTextList = [];

      Object.values(this.tableNameMap).forEach((val) => {
        headerTextList.push(val.label);

        let content = "";
        switch(val.name) {
          case "patientCode":
          case "patientMobilePhone":
          case "cpapBillingTargetCode":
          case "cpapBillingTargetName":
            content = this.convertDisplayByDeviceType(this.callDetailData[val.name]);
            break;
          case "deviceItemCode":
            content = this.convertDeviceModelName();
            break;
          case "callStatus":
            let status = this.callStatusList.find(item => item.code == this.callDetailData[val.name]);
            content = status ? status.name : "";
            break;
          default:
            content = this.callDetailData[val.name];
            content = content ? String(content) : "";
            break;
        }

        content = content ? content.replace(/\r?\n/g, " ") : "";
        dataTextList.push(content);
      });

      copyPasteText = headerTextList.join("\t");
      copyPasteText += "\n";
      copyPasteText += dataTextList.join("\t");

      navigator.clipboard
        .writeText(copyPasteText)
        .then(() => {
          this.showMessage("クリップボードにコピーしました。");
        })
        .catch(() => {
          this.showMessage("コピーに失敗しました");
        });
    },
  },
  computed: {
    screenTitleName() {
      if (this.callId.startsWith("C")) {
        return "コール詳細";
      } else if (this.callId.startsWith("D")) {
        return "返却詳細";
      } else {
        return "";
      }
    },
    callTypeTitleName() {
      let text = "";
      let finding = this.callTypeList.find(
        (item) => item.code == this.callDetailData.callType
      );
      if (finding) {
        text = finding.name;
      }
      return text;
    },
    calculateCallTurnaroundTimes() {
      this.isInvalidTimeSetting = false;
      let callTurnaroundTimes = "";
      if (
        this.callDetailData.callStartTime &&
        this.callDetailData.callEndTime
      ) {
        let now = new Date();
        let startHour = this.callDetailData.callStartTime.split(":")[0];
        let startMinutes = this.callDetailData.callStartTime.split(":")[1];
        let endHour = this.callDetailData.callEndTime.split(":")[0];
        let endMinutes = this.callDetailData.callEndTime.split(":")[1];
        let fromTime = new Date(
          now.getFullYear(),
          now.getMonth() + 1,
          now.getDate(),
          startHour,
          startMinutes
        );
        let toTime = new Date(
          now.getFullYear(),
          now.getMonth() + 1,
          now.getDate(),
          endHour,
          endMinutes
        );
        callTurnaroundTimes = (toTime - fromTime) / (60 * 1000);
        if (callTurnaroundTimes < 0) {
          callTurnaroundTimes = "";
          if(this.callStartHour != "" &&
            this.callStartMinutes != "" &&
            this.callEndHour != "" &&
            this.callEndMinutes != ""
          ) {
            this.isInvalidTimeSetting = true;
          }
        }
        this.callDetailData.callTurnaroundTimes = callTurnaroundTimes;
      }
      return callTurnaroundTimes;
    },
  },
  created() {
    this.callId = this.$route.params["callId"];
    this.searchParams = this.$route.params["searchConditions"];
    this.isCall = this.callId.startsWith("C");
    this.findInspectionDevices();
  },
  mounted() {
    this.findCallDetail();
  },
};
</script>

<style scoped>
#call-detail {
  width: 94%;
  margin: 0 auto;
}
.title-label {
  background-color: #000894;
  color: whitesmoke;
  text-align: left;
  padding-left: 10px;
  padding-right: 10px;
  margin-top: 10px;
}
.call-type-label {
  font-size: 20px;
}
.attention {
  margin: 1em 0;
  font-size: 18px;
}
.button-area {
  margin: 1em 0;
  height: 36px;
}
.clipboard-copy-button {
  width: 180px;
  height: 100%;
  float: left;
}
.strong {
  font-size: 18px !important;
  font-weight: bold;
}
#call-detail-content-area {
  display: flex;
  height: 100%;
}
#left-area {
  width: 50%;
}
.call-detail-content {
  padding: 10px;
  width: 100%;
  border: 1px solid;
  border-radius: 5px;
}
.call-detail-content table tr th,
.call-detail-content table tr td,
.history table tr th,
.history table tr td {
  font-size: 15px;
  vertical-align: middle;
  padding-top: 5px;
}
.call-detail-content table tr th {
  width: 30%;
}
.call-detail-content table tr td > * {
  width: 100%;
}
.call-detail-content table tr td .time-select,
.call-detail-content table tr td .turnaround-times {
  width: 50px;
}
.call-detail-content table tr td .date-select {
  width: 140px;
}
.call-detail-content table tr .hearing-th {
  vertical-align: top;
}
.call-detail-content table tr td .hearing-content {
  resize: vertical;
  max-width: 100%;
  height: 60px;
}
#right-area {
  width: 50%;
  margin-left: 10px;
}
.content-label {
  color: #ffffff;
  background: #000894;
}
.cpap-request-detail {
  padding: 1em;
  margin-bottom: 1em;
  border: 1px solid;
  border-radius: 5px;
  min-height: 600px;
  max-height: 600px;
  overflow: auto;
}
.history {
  padding: 10px;
  width: 100%;
  border: 1px solid;
  border-radius: 5px;
  min-height: 550px;
  max-height: 550px;
  overflow: auto;
}
.save-button,
.escalation-button {
  width: 180px;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/call/CpapFollowUpCallDetail.vue